module.exports = __webpack_public_path__ + "static/media/Flareon_gaussian2.ce1c8f65.png";